import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import CardExame from './CardExames.js'

const CardExamesContainer = ({ isMobile }) => {
  const data = useStaticQuery(graphql`
     {
       allWordpressAcfServicesForYou {
         edges {
           node {
             acf {
              service_link
              tag
              service_title
              service_text
              service_image {
                source_url
                localFile {
                  url
                  childImageSharp{
                    fluid {
                      base64
                      tracedSVG
                      srcWebp
                      srcSetWebp
                      originalImg
                      originalName
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  const dataCard = data.allWordpressAcfServicesForYou.edges

  return <CardExame isMobile={isMobile} dataCard={dataCard} />
} 

export default CardExamesContainer
